export default {"src":"/uk/_next/static/media/spot-icons-60px.6c501d40.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};